@if(!isMobile) {
<div class="ppl-mt8">
  <div class="d-flex justify-content-between">
    <h2 tabindex="-1" pplAutoFocusHeader>Forms</h2>
  </div>
</div>
}

@if(checkListData && checkListData.length > 0) {
<div class="d-flex" style="display: flex; gap: 8px;">
  <!-- Collapsible menu for buttons -->
  <div class="d-flex justify-content-end" id="mobileMenu">
    @if(!isMobile){
    <div class="custom-row justify-content-start">
      <div class="mr-2">
        <ppl-button label="Expand All" icon="fa fa-expand" [customClass]="'ghost-button mr-2'" [iconPosition]="'right'"
          (click)="expandAll()"></ppl-button>
      </div>

      <div class="mr-2">
        <ppl-button label="Collapse All" icon="fa fa-compress" [customClass]="'ghost-button mr-2'"
          [iconPosition]="'right'" (click)="hideAll()"></ppl-button>
      </div>
    </div>
    }
    @if(!isMobile){
    <div class="custom-row justify-content-start no-top-margin">
      <div class="mr-2">
        <ppl-button label="Download All" icon="fa fa-download" [customClass]="'ghost-button'" [iconPosition]="'right'"
          (click)="downloadAll()"></ppl-button>
      </div>
      <!-- Conditional Mail All button -->
      <ng-container *ngIf="!readonly && !isNewReferral">
        <div class="mr-2">

          <ppl-button label="Mail All" icon="fa fa-envelope" customClass="ghost-button mr-2" iconPosition="right"
            (click)="showMailAllDialog()"></ppl-button>
        </div>
      </ng-container>
    </div>
    }
  </div>
</div>
}
<div class="flex-col" style="gap: 8px;">
  @if(checkListData && checkListData.length > 0) {
  @for(checkList of checkListData; track $index) {
  <div class="mb-2">

    @if(actions) {
    @if(isMobile) {
    <div class="checklist-header-item alert mobile-primary">
      <div>
        @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size" aria-hidden="true"></i> }
        {{checkList.checklistName}}
      </div>
      <div [class]="checkList.isCompleted ? 'completed-count' : ''">
        {{checkList.totalItemsCompleted +'/' +checkList.totalItems}} Completed
      </div>
    </div>

    <div class="card-layout">
      <div class="card" *ngFor="let row of checkList.items">
        <div class="card-item">
          <strong>{{ row.formDesc }} </strong>
          <div class="status small-font"
            [ngClass]="{'completed': row.status === 'Completed', 'not-completed': row.status !== 'Completed'}">
            {{ row.status }}
          </div>
        </div>
        <div class="card-item">
          <div class="btn-group">
            <div class="custom-row">
              @if(row.formMasterId !== 74) {
              <div class="mr-1">
                <ppl-button ariaLabel="Edit" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" [disabled]="isPaymentFormBlocked(row)"
                  (click)="action({data: row, action: 'edit'}, false)"></ppl-button>
              </div>
              }
              <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
                [iconPosition]="'left'" (click)="action({data: row, action: 'download'}, false)"></ppl-button>
              @if(showFreezeToggle(row)) {
              <div class="ml-1">
                <ppl-button [ariaLabel]="freezeState.frozen ? 'Unfreeze changes' : 'Freeze changes'"
                  [label]="freezeState.frozen ? 'Unfreeze' : 'Freeze'"
                  [icon]="freezeState.frozen ? 'fa fa-unlock' : 'fa fa-lock'" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="toggleFreeze()"></ppl-button>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <nz-collapse [nzExpandIconPosition]="'end'" (click)="updateChecklistActivity(checkList)"
      [ngClass]="checkList.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
      <nz-collapse-panel [nzActive]="isPanelActive(checkList)" [nzHeader]="associationHeader">

        <ng-template #associationHeader>
          <div class="checklist-header-item" tabindex="0" (keydown.enter)="onPanelHeaderKeyPress(checkList)">
            <div>
              @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size" aria-hidden="true"></i> }
              {{checkList.checklistName}}
            </div>
            <div class="completed-count">
              {{checkList.totalItemsCompleted +'/' +checkList.totalItems}} Completed
            </div>
          </div>
        </ng-template>
        <ng-container *ngIf="isPanelActive(checkList)">
          <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="checkList.items"
            [disableSelection]="true" [cols]="participantCols" [gridTitle]="false" [pagination]="false" [buttonConfig]="buttonConfig" 
            [loadPage]="true" [actionButtons]="participantTableActions" (gridAction)="action($event, false)"></ppl-list-table>
        </ng-container>
      </nz-collapse-panel>
    </nz-collapse>
    }
    }

  </div>
  }
  }
  @else if (isSelf){
  <nz-alert nzType="info" tabindex="0" nzMessage="No Self forms available for you." nzShowIcon></nz-alert>
  }

  @if(prvdrAssociations && prvdrAssociations.length > 0) {
  <div class="ppl-mt16 flex-col" style="gap: 8px;">


    @if(isMobile) {
    <div class="checklist-header-item alert mobile-primary">
      <div>
        Offer Letters
      </div>
    </div>

    <div class="card-layout">
      <div class="card" *ngFor="let association of prvdrAssociations">
        <div class="card-item">
          <strong>{{ association.participantFirstName }} {{ association.participantLastName }}</strong>
        </div>
        <div class="card-item d-flex justify-content-between">
          <div class="mt-3">
            {{association.providerTypeLabel}}
            <div>
              Start Date : {{association.associationStartDate}} @if(association.associationEndDate) { -
              {{association.associationEndDate}}}
            </div>
          </div>
          <div class="btn-group mb-3">
            <ppl-button ariaLabel="View" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="action({data: association, action: 'view'}, false)"></ppl-button>
          </div>
        </div>
      </div>
    </div>

    } @else {
    <nz-collapse [nzExpandIconPosition]="'end'" (click)="updateChecklistActivity(offerLettersGroup)"
      [ngClass]="'pending pending-ant-collapse'" [attr.data-checklist-id]="offerLettersGroup.checklistName">
      <nz-collapse-panel [nzActive]="isPanelActive(offerLettersGroup)" [nzHeader]="offerLettersHeader">
        <ng-template #offerLettersHeader>
          <div class="checklist-header-item" tabindex="0" (keydown.enter)="onPanelHeaderKeyPress(offerLettersGroup)">
            <div>
              Offer Letters
            </div>
          </div>
        </ng-template>
        <ng-container *ngIf="isPanelActive(offerLettersGroup)">
          <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="prvdrAssociations"
            [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
            (gridAction)="action($event, true)" [actionButtons]="participantAssociationActions">
          </ppl-list-table>
        </ng-container>
      </nz-collapse-panel>
    </nz-collapse>
    }
  </div>

  }
</div>


<div class="filter-panel">

  <ng-template #pdfDialog let-cancel="cancel">
    @if (!readonly) {
    <div class="action-panel">
      <div class="error-message fs-6" *ngIf="errors && errors.length > 0 && customError == ''">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ getErrorMessage(errors[0]) }}
      </div>

      <div class="error-message fs-6" *ngIf="customError">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ customError }}
      </div>

      <ppl-button label="Save Form" icon="fa fa-check-circle" [customClass]="'primary-button'" [disabled]="disableSave"
        [iconPosition]="'left'" (handleClick)="handleSave()" />
    </div>
    }
    <div class="pdf-dialog-viewer" *ngIf="pdfConfig && pdfFile">
      <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="readonly" [pdfConfig]="pdfConfig"
        #viewEditPDFComponent [signature]="signature" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
        [signatureId]="signatureId" [isParticipantFlow]="isParticipantFlow" [isI9Form]="actionType !== 'view' && isI9Form" [isW4Form]="isW4Form" [formStatus]="selectedForm?.formStatus"
        [selectedParticipantId]="selectedParticipantId" [isPdfSubmitted]="isPdfSubmitted"
        [selectedProviderType]="selectedProviderType" [isSelf]="isSelf" [resignRequired]="resignRequired"
        [ignorePartBValidationOfI9]="!isAdmin && isI9Form" viewerHeight="100%"></ppl-editpdf>
    </div>
  </ng-template>
  <ng-template #showChangesDialog let-cancel="cancel">
    @if (!readonly) {
    <div class="action-panel">
      <div class="error-message fs-6" *ngIf="errors && errors.length > 0 && customError == ''">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ getErrorMessage(errors[0]) }}
      </div>

      <div class="error-message fs-6" *ngIf="customError">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ customError }}
      </div>

      <ppl-button label="Save Form" icon="fa fa-check-circle" [customClass]="'primary-button'" [disabled]="disableSave"
        [iconPosition]="'left'" (handleClick)="handleSave()" />
    </div>
    }
    <div class="pdf-summary-wrapper" *ngIf="pdfConfig && pdfFile">
      <div class="pdf-panel">
        <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="readonly" [pdfConfig]="pdfConfig"
          #viewEditPDFComponent [signature]="signature" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
          [signatureId]="signatureId" [isParticipantFlow]="isParticipantFlow" [isW4Form]="isW4Form"
          [selectedParticipantId]="selectedParticipantId" [isPdfSubmitted]="isPdfSubmitted"
          [selectedProviderType]="selectedProviderType" [isSelf]="isSelf" [resignRequired]="resignRequired"
          [ignorePartBValidationOfI9]="!isAdmin && isI9Form" [highlightedFields]="highlightedFields"
          [viewerHeight]="CHANGES_DIALOG_VIEWER_HEIGHT"></ppl-editpdf>
      </div>
      <div class="summary-panel">
        <h3 class="sub-header" tabindex="0">Summary of Changes</h3>
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="highlightedFields"
          [disableSelection]="true" [cols]="summaryCols" [gridTitle]="false" [pagination]="true"
          [loadPage]="true"></ppl-list-table>
      </div>
    </div>
  </ng-template>
  <ng-template #associationsDialog>
    @if(providerAssociationChecklist && providerAssociationChecklist.length > 0) {
    @for(checkList of providerAssociationChecklist; track $index) {
    <div class="p-2 mb-2">


      @if(isMobile) {
      <div class="checklist-header-item alert mobile-primary">
        <div>
          @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size" aria-hidden="true"></i> }
          {{checkList.checklistName}}
        </div>
        <div>
          {{checkList.totalItemsCompleted +'/' +checkList.totalItems}} Completed
        </div>
      </div>
      <div class="card-layout">
        <div class="card" *ngFor="let row of checkList.items">
          <div class="card-item">
            <strong>{{ row.formDesc }} </strong>
            <div class="status"
              [ngClass]="{'completed': row.status === 'Completed', 'not-completed': row.status !== 'Completed'}">
              {{ row.status }}
            </div>
          </div>
          <div class="card-item">
            <div class="btn-group">
              <div class="custom-row">
                @if(row.formMasterId !== 74) {
                <div class="mr-1">
                  <ppl-button ariaLabel="Edit" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" [disabled]="isPaymentFormBlocked(row)"
                    (click)="action({data: row, action: 'edit'}, true)"></ppl-button>
                </div>
                }
                <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="action({data: row, action: 'download'}, true)"></ppl-button>
                @if(showFreezeToggle(row)) {
                <div class="ml-1">
                  <ppl-button [ariaLabel]="freezeState.frozen ? 'Unfreeze changes' : 'Freeze changes'"
                    [label]="freezeState.frozen ? 'Unfreeze' : 'Freeze'"
                    [icon]="freezeState.frozen ? 'fa fa-unlock' : 'fa fa-lock'" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="toggleFreeze()"></ppl-button>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <nz-collapse [nzExpandIconPosition]="'end'" (click)="updateChecklistActivity(checkList)"
        [ngClass]="checkList.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
        <nz-collapse-panel [nzActive]="true" [nzHeader]="associationHeader">

          <ng-template #associationHeader>
            <div class="checklist-header-item">
              <div>
                @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size" aria-hidden="true"></i> }
                {{checkList.checklistName}}
              </div>
              <div [class]="checkList.isCompleted ? 'completed-count' : ''">
                {{checkList.totalItemsCompleted +'/' +checkList.totalItems}} Completed
              </div>
            </div>
          </ng-template>
          <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="checkList.items"
            [disableSelection]="true" [cols]="participantCols" [gridTitle]="false" [pagination]="false" [buttonConfig]="offerButtonConfig"
            [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event, true)"></ppl-list-table>
        </nz-collapse-panel>
      </nz-collapse>
      }
    </div>
    }
    } @else {
    <nz-alert nzType="info" nzMessage="Forms are not applicable to your association with the consumer."
      nzShowIcon></nz-alert>
    }
  </ng-template>

  <ng-template #formHistoryDialog>
    @if(formHistoryChecklist && formHistoryChecklist.length > 0) {
    @for(checkList of formHistoryChecklist; track $index) {
    <div class="mb-3">
      <h2 class="sub-header">{{ checkList.checklistName }}</h2>
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="checkList.items"
        [disableSelection]="true" [cols]="formHistoryCols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
        [actionButtons]="actions" (gridAction)="action($event, false)">
      </ppl-list-table>
    </div>
    }
    } @else {
    <nz-alert nzType="info" nzMessage="There is no history available for this form." nzShowIcon></nz-alert>
    }
  </ng-template>

</div>

<ppl-popup-dialog [(isVisible)]="showConfirmationDialog" title="Confirm Mail All" isOkText="Mail All Forms"
  (cancel)="onCloseDialog()" [showButtons]="true" position="top" size="medium" (confirm)="handleConfirmMailAll()">
  <div>
    <h3 class="ppl-gray-text mb-4">
      Are you sure you wish to mail all forms?
    </h3>
    <p>
      This action cannot be undone.
    </p>
  </div>
</ppl-popup-dialog>

<ng-template #confirmationDialog2 let-confirm="confirm" let-cancel="cancel">
  <div>
    <h3 class="ppl-gray-text mb-4">
      Are you sure you wish to mail form?
    </h3>
    <p>
      This action cannot be undone.
    </p>
  </div>
</ng-template>

<ng-template #confirmationDialogForEditingPaymentForm let-confirm="confirm" let-cancel="cancel">
  <div>
    <p>
      For your security, additional verification is needed to process your payment method update request. Please allow
      up to 5 business days to process your request. In the meantime, you may receive a paper check.
    </p>
  </div>
</ng-template>

<ng-template #freezeConfirmDialog>
  @if(freezeState.frozen){
  <p>
    Unfreezing will allow PPL staff to edit this account's Payment Method Form again.
    Are you sure?
  </p>
  } @else {
  <p>
    Freezing will stop PPL staff from editing this account's Payment Method Form.
    You and the account holder can still make changes. This does not affect Contact
    Details. Are you sure?
  </p>
  }
</ng-template>

<ng-template #i9SaveDialog let-confirm="confirm" let-cancel="cancel">
  <div>
    <p>
      Please make sure the First and Last Name you enter match the names on the List A or List B & List C documents you are providing. This will help ensure your information is correct for the USCIS I-9 Form.
    </p>
  </div>
</ng-template>